
// The builder's option card (#721 spec §8.2; round-2 spec §13.4): one per
// option, the recommendation first. All prose comes from the engine as
// escaped HTML; the copay table and the provider table are the existing
// components. Store plans (summaryPlansMap) feed the components, engine plans
// feed the prose. The current plans' costs live in card/CurrentPlanCosts.vue.
import card from '~/mixins/card'
import * as aep from '~/util/aep-recommendation'

export default {
    mixins: [card],
    props: {
        magicUrl: { type: String, default: '/' },
        mode: { type: [String, Object], default: 'default' },
        aep: { type: Boolean, default: null },
        index: { type: Number, default: null },
        comboIndex: { type: Number, default: null },
    },
    computed: {
        // The option this combo card renders, found by its plan ids; the
        // recommendation when the card carries no plans (tests, legacy keys).
        ctx () {
            const root = this.aepContext
            const ids = (this.comboPlans || []).map(p => p.id)
            if (!ids.length) { return root }
            const same = o => o.resulting.length === ids.length && o.resulting.every(p => ids.includes(p.id))
            return aep.options(root).find(same) || root
        },
        header () {
            return aep.cardHeader(this.ctx)
        },
        // the primary option only: an alternative's card does not repeat it
        terminated () {
            return this.ctx.alternative ? '' : aep.terminatedIntroHtml(this.ctx)
        },
        intro () {
            return aep.introHtml(this.ctx)
        },
        note () {
            return this.ctx.alternative ? '' : aep.noteHtml(this.ctx.note)
        },
        showNetwork () {
            return !!this.summaryCardsMap.providers_network
        },
        resultingStorePlans () {
            return this.ctx.lines.map(l => this.summaryPlansMap[l.plan.id]).filter(Boolean)
        },
        rxPlan () {
            return this.resultingStorePlans.find(p => p.pdp || p.mapd_or_ma) || null
        },
        medPlan () {
            return this.resultingStorePlans.find(p => p.supp || p.mapd_or_ma) || null
        },
    },
    methods: {
        engine (plan) {
            return this.ctx.plansById[plan.id]
        },
        detail (line) {
            return aep.planDetailHtml(this.ctx, line)
        },
    },
}
